// extracted by mini-css-extract-plugin
export default {"container":"y6T5jC42xxKlOBJvo8Pz","marginBottom":"EzpFqwEfGMPhRnE7cdB8"};